
import { AdminDataErrorViewResponse } from "../types/adminDataErrorReponse";
import axiosInstance from "./axiosInstance";

export const getAdminDataError = async (): Promise<AdminDataErrorViewResponse[]> => {
  try {
    const response = await axiosInstance.get(
      "/api/admin/error-view",
      {
        params: { all:true },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching admin error-view data:", error);
    throw error;
  }
};
export const retryDataError = async (
  errorIds: string[]
): Promise<any> => {
  try {
    const response = await axiosInstance.post(
      `api/admin/retry`, // API endpoint with query params
      errorIds // Body of the POST request
    );
    return response.data; // Return the server response
  } catch (error) {
   
    return error; // Rethrow the error to be handled by calling code
  }
};